<template>
  <div class="c-bg--gray c-common-footer-fixed">
    <div class="c-common-footer-fixed__inner">
      <TheHeader ref="theHeader" />
      <div ref="content" class="p-the-page-j05">
        <div class="c-common-inner">
          <div class="p-the-page-j05__inner">
            <div
              class="p-thread-header"
            >
              <span class="p-thread-header__back" @click="goMessageList">❮</span>

              <IconUserImage :size="32">
                <img :src="partnerUserImage" alt />
              </IconUserImage>

              <span class="p-thread-header__name" data-translate-skip>
                {{ partnerUserName }}
              </span>
              <button
                v-if="sendApproval == 1"
                class="p-thread-header__thanks-btn"
                :style="{ background: colorCode }"
                @click="goGiveThanksPoint"
              >
                この人に贈る
              </button>
            </div>

            <div class="p-the-page-j05__body">
              <div
                ref="chatContainer"
                class="p-the-page-j05__chat-container"
              >
                <TheJ05ChatScreen
                  :chat-log="internalChatLog"
                  :unread-row-no="unreadRowNo"
                  :partner-user-image="partnerUserImage"
                />
              </div>
              <div
                v-if="thread_enabled && sendApproval == 1"
                ref="textareaElement"
                class="p-the-page-j05__form"
              >
                <TheJ05ChatForms @do-send="doSend" />
              </div>
              <div class="p-the-page-j05__message__note" v-if="!thread_enabled"></div>
              <div class="p-the-page-j05__message__note" v-if="thread_enabled && sendApproval == 2">
                <SmallText>
                  この人へ新規メッセージ送信はできません。
                </SmallText>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script lang="ts">
import TheJ05ChatScreen from "@/general/components/pages/parts/ThanksPointMessage/TheJ05ChatScreen.vue";
import TheJ05ChatForms from "@/general/components/pages/parts/ThanksPointMessage/TheJ05ChatForms.vue";
import { Options, Vue } from "vue-class-component";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import ThanksPointApi from "@/general/api/thanksPointApi";
import {
  ThanksMessageThreadResponse,
  ChatLogItem
} from "@/general/store/models";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import loginInfo from "@/general/store/modules/loginInfo";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";

@Options({
  name: "ThanksPointMessage",
  props: {
    tempChat: { type: [Array], required: true }
  },
  components: {
    TheJ05ChatScreen,
    TheJ05ChatForms,
    IconUserImage
  },
  directives: {
    scroll(el: any, binding: any) {
      const f = function(evt: any) {
        if (binding.value(evt, el)) {
          window.removeEventListener("scroll", f);
        }
      };
      window.addEventListener("scroll", f);
    }
  }
})
export default class ThanksPointMessage extends Vue {
  tempChat!: any;
  ssoFlg = false;
  partnerUserId = 0;
  threadTargetUserId = 0;
  chatLog: ChatLogItem[] = [];
  internalChatLog: ChatLogItem[] = [];
  sendApproval = 0;

  unreadKeyNo = 0;
  unreadRowNo = -1;

  isLoadingPrevious = false;
  isLoadingNext = false;
  maxRowNo: number | null = null;
  partnerUserImage = "";
  partnerUserName = "";
  refreshTimer: number | null = null;
  restoringScroll = false;

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }


  get thread_enabled() {
    return auth.user.thread_enabled;
  }

  goMessageList() {
    window.location.href = SITE_MAP.THANKS_POINT;
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const userDetails = LocalStorage.getItem("userDetails");
    const settings = userDetails ? JSON.parse(userDetails) : null;
    if (settings == null || settings.thanks_point_enabled === false) {
      window.location.href = "/home";
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const userId = Number(urlParams.get("id"));
    this.threadTargetUserId = userId;
    if (Number.isNaN(userId)) {
      window.location.href = SITE_MAP.THANKS_POINT;
      return;
    }

    const response: ThanksMessageThreadResponse = await ThanksPointApi.getThanksThreadMessages(
      this.threadTargetUserId
    );

    if (!response || !response.results) {
      window.location.href = SITE_MAP.THANKS_POINT;
      return;
    }

    // DC_IC-942
    if (response.results && response.results.length > 0) {

      if (response.toThanksFlg) {
        this.partnerUserId = userId;
          this.sendApproval = 1;
      } else {
          this.sendApproval = 2;
      }

      if (response.totalCount != null) {
        this.maxRowNo = response.totalCount;
      }

      this.chatLog = response.results.map((resObj, index) => ({
        rowNo: resObj.rowNo,
        isYouSent: resObj.mine,
        isThanksMessage: resObj.isThanksMessage,
        title: resObj.thanksTitle,
        point: resObj.point,
        message: resObj.message,
        date: resObj.registerDatetime,
        badgeIcon: resObj.badgeIcon,
        badgeName: resObj.badgeName,
        key: index,
        unread: !resObj.hasRead
      }));

      if (response.toUserInfoData) {
        this.partnerUserImage = response.toUserInfoData.user_image;
        this.partnerUserName = response.toUserInfoData.isDeleted ? "" : response.toUserInfoData.user_name;
      }

      this.internalChatLog = this.chatLog;

      const unreadMessage = this.chatLog.find(
        (chat: ChatLogItem) => chat.unread
      );

      this.unreadRowNo = unreadMessage?.rowNo ?? -1;

      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs.chatContainer as HTMLElement;

          if (!container) {
            return;
          }

          if (this.unreadRowNo > 0) {
            const target = document.getElementById(`chat-${this.unreadRowNo}`);

            if (target) {
              container.scrollTop = target.offsetTop - 250;
            }
          } else {
            container.scrollTop = container.scrollHeight;
          }
        }, 50);
      });
    }
  }

  async mounted() {
    AuthStorage.checkLogin();

    const chatContainer = this.$refs.chatContainer as HTMLElement;
    chatContainer.addEventListener(
      "scroll",
      this.handleScroll
    );

    this.refreshTimer = window.setInterval(this.autoLoadNextMessages, 60000);

    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  beforeUnmount() {
    const chatContainer = this.$refs.chatContainer as HTMLElement;
    chatContainer?.removeEventListener(
      "scroll",
      this.handleScroll
    );

    if (this.refreshTimer != null) {
      clearInterval(this.refreshTimer);
    }

    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  async doSend(value: any) {
    const response =
      await ThanksPointApi.postThanksPointMessage(
        this.threadTargetUserId,
        value.message
      );

    if (!response) {
      return;
    }

    const latest =
      await ThanksPointApi.getThanksThreadMessages(
        this.threadTargetUserId
      );

    if (!latest?.results?.length) {
      return;
    }

    this.maxRowNo = latest.totalCount;

    this.chatLog = latest.results.map((resObj, index) => ({
      rowNo: resObj.rowNo,
      isYouSent: resObj.mine,
      isThanksMessage: resObj.isThanksMessage,
      title: resObj.thanksTitle,
      point: resObj.point,
      message: resObj.message,
      date: resObj.registerDatetime,
      badgeIcon: resObj.badgeIcon,
      badgeName: resObj.badgeName,
      key: index,
      unread: !resObj.hasRead
    }));

    this.internalChatLog = this.chatLog;

    await this.$nextTick();
    requestAnimationFrame(() => {
      this.scrollToBottom();
    });
  }

  scrollToBottom() {
    const container = this.$refs.chatContainer as HTMLElement;
    container.scrollTop = container.scrollHeight;
  }

  get colorCode() {
    return commons.colorCode;
  }

  goGiveThanksPoint() {
    LocalStorage.setItem("partnerUserId", String(this.partnerUserId));
    window.location.href = "/thanks-point/give-thanks-point/";
  }

  handleScroll() {
    if (this.restoringScroll || this.isLoadingPrevious || this.isLoadingNext) {
      return;
    }
    const container = this.$refs.chatContainer as HTMLElement;
    const scrollTop = container.scrollTop;

    if (scrollTop <= 10) {
      this.loadPreviousMessages();
      return;
    }

    const scrollBottom = container.scrollTop + container.clientHeight;
    const documentHeight = container.scrollHeight;

    if (documentHeight - scrollBottom <= 10) {
      this.loadNextMessages();
    }
  }

  get oldestRowNo() {
    return this.chatLog.length > 0
      ? this.chatLog[0].rowNo
      : null;
  }

  get newestRowNo() {
    return this.chatLog.length > 0
      ? Math.max(
          ...this.chatLog.map(
            chat => chat.rowNo
          )
        )
      : null;
  }

  get hasNextMessages() {
    return (
      this.newestRowNo != null &&
      this.maxRowNo != null &&
      this.newestRowNo < this.maxRowNo
    );
  }

  async loadPreviousMessages() {
    const anchorRowNo = this.oldestRowNo;
    if (this.oldestRowNo == null || this.oldestRowNo <= 1) {
      return;
    }

    this.isLoadingPrevious = true;

    const container = this.$refs.chatContainer as HTMLElement;
    const beforeScrollHeight = container.scrollHeight;

      const startRow = Math.max(1, this.oldestRowNo - 75);
      const endRow = startRow + 99;

      const response =
        await ThanksPointApi.getThanksThreadMessages(
          this.threadTargetUserId,
          startRow,
          endRow
        );
      if (!response?.results?.length) {
        this.isLoadingPrevious = false;
        return;
      }
      const previousMessages =
        response.results.map((resObj, index) => ({
        rowNo: resObj.rowNo,
        isYouSent: resObj.mine,
        isThanksMessage: resObj.isThanksMessage,
        title: resObj.thanksTitle,
        point: resObj.point,
        message: resObj.message,
        badgeIcon: resObj.badgeIcon,
        badgeName: resObj.badgeName,
        date: resObj.registerDatetime,
        key: index,
        unread: !resObj.hasRead
      }));

      this.chatLog = previousMessages;
      this.internalChatLog = this.chatLog;

      this.$nextTick(() => {
        const target =
          document.getElementById(`chat-${anchorRowNo}`);

        if (!target) {
          this.restoringScroll = false;
          this.isLoadingPrevious = false;
          return;
        }

        const container =
          this.$refs.chatContainer as HTMLElement;

        this.restoringScroll = true;
        container.scrollTop = target.offsetTop - container.clientHeight / 3;
        setTimeout(() => {
          this.restoringScroll = false;
          this.isLoadingPrevious = false;
        }, 200);
      });

  }

  async loadNextMessages() {
    if (!this.hasNextMessages || this.newestRowNo == null) {
      return;
    }

    this.isLoadingNext = true;
    this.restoringScroll = true;

    const anchorRowNo = this.chatLog[Math.max(0, this.chatLog.length - 25)]?.rowNo;

    const targetBefore =
      document.getElementById(`chat-${anchorRowNo}`);

    if (!targetBefore) {
      this.restoringScroll = false;
      this.isLoadingNext = false;
      return;
    }

    const beforeTop = targetBefore.getBoundingClientRect().top;

    const endRow = Math.min(this.maxRowNo!, this.newestRowNo + 75);

    const startRow =
      Math.max(1, endRow - 99);

    const response =
      await ThanksPointApi.getThanksThreadMessages(
        this.threadTargetUserId,
        startRow,
        endRow
      );

    if (!response?.results?.length) {
      this.restoringScroll = false;
      this.isLoadingNext = false;
      return;
    }

    const nextMessages =
      response.results.map((resObj, index) => ({
        rowNo: resObj.rowNo,
        isYouSent: resObj.mine,
        isThanksMessage: resObj.isThanksMessage,
        title: resObj.thanksTitle,
        point: resObj.point,
        message: resObj.message,
        badgeIcon: resObj.badgeIcon,
        badgeName: resObj.badgeName,
        date: resObj.registerDatetime,
        key: index,
        unread: !resObj.hasRead
      }));

    this.chatLog = nextMessages;
    this.internalChatLog = this.chatLog;

    await this.$nextTick();

    requestAnimationFrame(() => {
      const targetAfter =
        document.getElementById(`chat-${anchorRowNo}`);

      if (!targetAfter) {
        this.restoringScroll = false;
        this.isLoadingNext = false;
        return;
      }

      const afterTop = targetAfter.getBoundingClientRect().top;
      const container = this.$refs.chatContainer as HTMLElement;
      container.scrollTop += afterTop - beforeTop;

      setTimeout(() => {
        this.restoringScroll = false;
        this.isLoadingNext = false;
      }, 200);
    });
  }

  async autoLoadNextMessages() {
    if (document.hidden || this.isLoadingNext) {
      return;
    }

    const container = this.$refs.chatContainer as HTMLElement;

    if (!container) {
      return;
    }

    const scrollBottom = container.scrollTop + container.clientHeight;
    const isAtBottom = container.scrollHeight - scrollBottom <= 100;

    if (!isAtBottom) {
     return;
    }

    const latest =
      await ThanksPointApi.getThanksThreadMessages(
        this.threadTargetUserId
      );

    this.maxRowNo = latest.totalCount;

    while (this.hasNextMessages) {
      await this.loadNextMessages();
    }

    await this.$nextTick();
    this.scrollToBottom();
  }

  handleVisibilityChange() {
    if (!document.hidden) {
      this.autoLoadNextMessages();
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-j05 {
  display: flex;
  flex-direction: column;
  height: auto;

  &__inner {
    @include pc {
      padding-top: rem(20);
    }

    @include sp {
      padding-top: rem(16);
    }
  }

  &__body {
    @include pc {
      width: 100%;
      max-width: 1400px;
    }
    margin: 0 auto;
  }

  &__form {
    position: relative;
    width: 100%;
    flex-shrink: 0;
    background-color: $common-bg;
  }
}

.p-the-page-j05__chat-container {
  display: flex;
  flex-direction: column;

  height: calc(100dvh - 310px);

  overflow-y: auto;
  overflow-x: hidden;

  background: $common-gray300;
  border: 1px solid #ddd;
  border-radius: 8px;

  @include pc {
    padding: 0 rem(24);
  }

  @include sp {
    height: calc(100dvh - 310px);
    padding: 0 rem(12);
  }
}

.p-the-j05-chat-screen {
  flex: unset;
  overflow: visible;
}

.p-thread-header {
  display: flex;
  align-items: center;

  &__thanks-btn {
    margin-left: auto;
    min-width: rem(120);
    height: rem(40);
    padding: 0 rem(16);
    border: none;
    border-radius: rem(6);
    color: #fff;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      opacity: .9;
    }

    @include sp {
      min-width: rem(90);
      height: rem(34);
      font-size: rem(12);
    }
  }

  margin-bottom: rem(12);

  &__back {
    font-size: rem(24);
    line-height: 1;
    margin-right: rem(8);
    color: #666;
    cursor: pointer;
  }

  &__name {
    margin-left: rem(12);
    font-weight: 700;

    @include pc {
      margin-left: rem(12);
      font-size: rem(20);
    }

    @include sp {
      margin-left: rem(8);
      font-size: rem(16);
    }
  }
}

.p-the-page-j05__message__note {
  text-align: center;
  padding: rem(14);
  font-size: 14px
}
</style>
